
import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import { ApolloResponse } from '@/interfaces/apollo'
import { showErrors } from '@/utils/snack'
import { getVehicle } from '@/modules/Vehicle/gql/vehicle.gql'

@Component
export default class AppQueries extends Vue {
  async getVehicle (vehicleId: number) {
    try {
      const result: ApolloResponse = await this.$apollo.query({
        query: getVehicle,
        variables: {
          vehicleId
        }
      })
      return result.data.getVehicle
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
  }
}
